import { StateType } from '../index';

export const flashMessagesAlphaDetailsMessageSelector = (state: StateType) => state.getIn(['flashMessages', 'messages', 'alpha-details']);
export const flashMessagesEditorCodeMessageSelector = (state: StateType) => state.getIn(['flashMessages', 'messages', 'editor-code']);
export const flashMessagesTopMessageSelector = (state: StateType) => state.getIn(['flashMessages', 'messages', 'top']);
export const flashMessagesTeamMessageSelector = (state: StateType) => state.getIn(['flashMessages', 'messages', 'team']);
export const flashMessagesTopGenericMessageSelector = (state: StateType) => state.getIn(['flashMessages', 'messages', 'top', 'generic']);
export const flashMessagesSimulationAlphasMessageSelector = (state: StateType) =>
  state.getIn(['flashMessages', 'messages', 'simulation-alphas']);
